import $ from 'jquery';
import Change from './Change';

const defaults = {
  vOffset: undefined,
};

function FadeText(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.vOffset = this.settings.vOffset;
  this.update();
  this.register();
}

FadeText.prototype = {
  register() {
    Change.onChange(setTimeout(this.update.bind(this), 500));
  },

  update() {
    const innerElem = this.$element.find('.node-header');
    const outerElem = this.$element.find('.node-inner');
    const padTop = parseInt(outerElem.css('padding-top'), 10);
    const padBottom = parseInt(outerElem.css('padding-bottom'), 10);
    const padOffset = padTop + padBottom;
    const vOffset = (this.vOffset) ? this.$element.find(this.vOffset).outerHeight(true) : 0;
    const innerHt = innerElem.outerHeight(true) + vOffset;
    const outerHt = outerElem.outerHeight(true) - padOffset;
    if (innerHt > outerHt) {
      this.$element.find('.node-teaser').addClass('fade-text');
    } else {
      this.$element.find('.node-teaser').removeClass('fade-text');
    }
  },
};

export default FadeText;
